import React from 'react';
import PropTypes from 'prop-types';
import { TableStatusBadge } from '../../components/badges';

const StatusCell = props => (
  <div className="d-flex align-items-center h-100">
    <div className="rt--status-container">
      <div className="rt--status">
        <TableStatusBadge task={props.value} />
      </div>
    </div>
  </div>
);

StatusCell.propTypes = {
  value: PropTypes.shape({}),
};

export default StatusCell;
